export interface Testimonial {
  name: string
  role: 'Judo Coach' | 'Judo Instructor'
  location: string
  text: string
  /** true until replaced with a verified customer review */
  isSample: boolean
}

// Sample reviews — replace with verified customer testimonials and set isSample to false.
export const shortTestimonials: Testimonial[] = [
  {
    name: 'Daniel Harper',
    role: 'Judo Coach',
    location: 'Denver, USA',
    text: 'I used to spend my Sunday evenings planning the week. Now I open the system, pick the objective and my sessions are ready in minutes — and they actually connect from one week to the next.',
    isSample: true,
  },
  {
    name: 'Laura Mendes',
    role: 'Judo Instructor',
    location: 'Porto, Portugal',
    text: 'The visual breakdowns are the best part. My kids understand Kuzushi so much faster when I show them the correct-vs-incorrect pages before we drill.',
    isSample: true,
  },
  {
    name: 'Tom Richardson',
    role: 'Judo Coach',
    location: 'Manchester, UK',
    text: 'The combination systems and the coaching cues bonus changed how I run Randori. It feels structured now instead of just another hard round.',
    isSample: true,
  },
]
